import React from 'react';
import { CSSEditorAction, CSSEditorMenuButton } from './style';
import { WidgetEditor } from 'jamespot-front-business';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';
import { useAppDispatch } from '../../redux/store';

const Icon = commonComponentsRegistry.getLazyComponent('Icon');

import { useTheme } from 'styled-components';

export const EditorPosition = ({ uniqid, position }: { uniqid: string; position: 'left' | 'right' }) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const onClick = () => {
        dispatch(
            WidgetEditor.slice.actions.setEditorPosition({ uniqid, position: position === 'left' ? 'right' : 'left' }),
        );
    };

    return (
        <CSSEditorAction>
            <CSSEditorMenuButton onClick={onClick}>
                <Icon
                    name={position === 'left' ? 'icon-angle-right' : 'icon-angle-left'}
                    color={theme.color.lavender}
                    size={26.75}
                />
            </CSSEditorMenuButton>
        </CSSEditorAction>
    );
};
